import {
  pricingTranslationsZh,
  featuresSectionZh,
  footerExtendedZh,
  organizationsZh,
  b2bContactZh,
  signInZh,
  a11yZh,
} from './marketingCopy.zh'
import { accountAdminCopyZh } from './accountAdminCopy/accountAdminCopy.zh'

export const zh = {
  hero: {
    title: 'Zporti',
    subtitle: '挑战你的朋友。预测比赛。一起获胜。',
    description:
      '与朋友创建体育预测挑战，跟踪你的胜利，并在排行榜上竞争。友好竞争和体育预测的终极平台。',
  },
  siteNav: {
    home: '首页',
    organizations: '组织管理',
    contact: '联系',
    packs: '定价',
    signIn: '登录',
    createAccount: '注册',
    openApp: '打开应用',
    signedInAs: '已登录',
    signedInNameFallback: '你的账户',
    signOut: '退出登录',
    signOutConfirmTitle: '退出登录？',
    signOutConfirmMessage: '退出后需要重新登录才能访问账户。',
    signOutConfirm: '退出',
    signOutCancel: '取消',
    signOutErrorTitle: '错误',
    signOutError: '无法退出，请重试。',
  },
  features: {
    title: '为什么选择 Zporti？',
    subtitle: '将体育预测转化为友好竞争所需的一切',
    challenge: {
      title: '挑战朋友',
      description:
        '创建自定义预测挑战并邀请你的朋友参与竞争。设置团队挑战或与个别朋友一对一竞争。',
    },
    track: {
      title: '跟踪结果',
      description:
        '查看实时比分，跟踪你的预测，并监控你的胜率。当比赛结果出来时立即收到通知。',
    },
    compete: {
      title: '竞争与获胜',
      description:
        '攀登排行榜，赢得吹牛的权利，看看谁是最好的预测者。庆祝胜利并跟踪你的长期进步。',
    },
    groups: {
      title: '群组与赛季感',
      description:
        '同一群好友可以跨多轮比赛一起玩，在群内对比排名，让挑战更像小型联赛，而不是单场即结束。',
    },
    locks: {
      title: '开球前锁定预测',
      description:
        '比赛开始即锁定预测，规则对所有人一致。结果按官方赛果自动结算，公平清晰、减少争议。',
    },
    organizations: {
      title: '组织与品牌',
      description:
        '俱乐部、企业与合作伙伴可使用自有配色、标识与成员席位，让你的社群在应用里保持统一形象。',
    },
    avatars: featuresSectionZh.avatars,
  },
  featuresSection: featuresSectionZh,
  howItWorks: {
    title: '工作原理',
    subtitle: '三个简单步骤即可开始',
    step1: {
      title: '创建挑战',
      description: '选择一场比赛，设置你的预测，并邀请朋友加入你的挑战。',
    },
    step2: {
      title: '做出预测',
      description: '每个参与者在比赛开始前做出预测。锁定你的选择并等待比赛开始。',
    },
    step3: {
      title: '看谁获胜',
      description: '比赛结束时自动计算结果。庆祝胜利并攀登排行榜。',
    },
  },
  competition: {
    title: '友好竞争，真实兴奋',
    description:
      '与朋友一起体验体育预测的刺激。无论你是休闲粉丝还是统计爱好者，Zporti 让每场比赛都更加精彩。挑战你的朋友，证明你的预测技能，看看谁最终胜出。',
  },
  stats: {
    challenges: '活跃挑战',
    users: '活跃用户',
    predictions: '已做预测',
    games: '跟踪比赛',
  },
  benefits: {
    title: '为什么选择 Zporti？',
    subtitle: '体育预测终极体验所需的一切',
    realTime: {
      title: '实时更新',
      description:
        '当比赛开始、比分更新和结果出来时，立即收到通知。通过实时比分跟踪和自动结果计算，不错过任何时刻。',
    },
    social: {
      title: '社交与连接',
      description:
        '通过 Gmail 与朋友联系，轻松邀请他们，并建立你的预测网络。创建团队挑战或与你最亲密的朋友一对一竞争。',
    },
    smart: {
      title: '智能预测',
      description:
        '跟踪赔率，分析比赛数据，做出明智的预测。查看历史表现、胜率和详细统计数据，以提高你的预测技能。',
    },
    fair: {
      title: '公平透明',
      description:
        '所有结果在比赛结束时自动计算。没有争议，没有手动计分 - 只有公平竞争和明确的获胜者。',
    },
  },
  faq: {
    title: '常见问题',
    subtitle: '关于 Zporti 你需要知道的一切',
    q1: {
      question: '如何邀请朋友？',
      answer:
        '你可以通过两种方式邀请朋友：连接你的 Gmail 账户以轻松选择联系人，或手动输入电子邮件地址。朋友将收到一个邀请链接来加入你的挑战。',
    },
    q2: {
      question: '预测何时锁定？',
      answer:
        '预测必须在比赛开始前进行。一旦比赛开始，所有预测都会被锁定，无法更改。这确保了每个人的公平竞争。',
    },
    q3: {
      question: '如何确定获胜者？',
      answer:
        '获胜者在比赛结束时自动计算。系统将所有预测与实际比赛结果进行比较，并实时更新排行榜。',
    },
    q4: {
      question: '我可以创建团队挑战吗？',
      answer:
        '可以！你可以与多个朋友创建挑战，或与个别朋友一对一竞争。设置团队竞赛，看看谁拥有最好的预测技能。',
    },
  },
  packsPage: {
    pageTitle: '方案与定价',
  },
  contact: {
    title: '联系我们',
    subtitle:
      '产品咨询、反馈、媒体或合作—可在下方留言或直接发邮件，我们都会查看。',
    emailLabel: '发送邮件至',
    email: 'info@zporti.com',
    form: {
      nameLabel: '姓名',
      emailLabel: '电子邮件',
      messageLabel: '消息',
      submitButton: '发送消息',
      submitting: '发送中...',
      successMessage: '谢谢！您的消息已发送。我们会尽快回复您。',
      errorMessage: '发送消息失败。请稍后再试。',
      namePlaceholder: '真实姓名',
      emailPlaceholder: 'your.email@example.com',
      messagePlaceholder: '告诉我们您的想法...',
      validation: {
        nameRequired: '姓名是必填项',
        nameTooLong: '姓名必须少于或等于50个字符',
        emailRequired: '电子邮件是必填项',
        emailInvalid: '请输入有效的电子邮件地址',
        messageRequired: '消息是必填项',
        messageTooLong: '消息必须少于或等于500个字符',
        invalidCharacters: '检测到无效字符。请删除任何特殊格式。',
      },
    },
  },
  footer: {
    title: '准备开始了吗？',
    subtitle: '立即加入 Zporti，开始挑战你的朋友。在几秒钟内创建你的第一个预测挑战。',
    privacyPolicy: '隐私政策',
    termsOfService: '服务条款',
    dataDeletion: '数据删除',
    credits: '鸣谢',
    privacyControls: '隐私控制',
    ...footerExtendedZh,
  },
  pricing: pricingTranslationsZh,
  organizations: organizationsZh,
  b2bContact: b2bContactZh,
  signIn: signInZh,
  a11y: a11yZh,
  accountAdmin: accountAdminCopyZh,
  legal: {
    backToHome: '返回首页',
    backToPrivacyAndData: '返回',
    privacyDocumentTitle: '隐私政策',
    dataDeletionDocumentTitle: '数据删除说明',
    termsDocumentTitle: '服务条款',
    creditsDocumentTitle: '鸣谢',
    aboutDocumentTitle: '关于 Zporti',
    supportDocumentTitle: '支持',
    documentVersionLine: '最后更新 {date} · 版本 {version}',
    privacyControlsCallout: '需要更改同意设置或申请数据副本吗？请在你的账户中打开隐私控制。',
    openPrivacyControls: '打开隐私控制',
    signInForPrivacyControls: '登录以打开隐私控制',
  },
  privacyControls: {
    title: '隐私控制',
    subtitle: '管理营销同意并请求账户数据副本。',
    marketingEmailsTitle: '营销邮件',
    marketingEmailsHint: '你可以随时选择加入或撤回同意。',
    analyticsTrackingTitle: '分析跟踪',
    analyticsTrackingHint: '为此设备/浏览器开启或关闭分析跟踪。',
    accountDataCopyTitle: '账户数据副本',
    accountDataCopyHint: '下载与你的账户关联的个人数据 JSON 副本（每 24 小时可用一次）。',
    enabled: '已启用',
    disabled: '已禁用',
    downloadMyData: '下载我的数据',
    nextExportAvailable: '下次可导出时间',
    close: '关闭',
    deleteYourAccount: '删除你的账户',
    deleteYourAccountHint: '在下一屏继续确认。这将永久删除你的账户及相关数据。',
  },
}

